import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import { bindActionCreators } from 'redux'
import { SubmissionError } from 'redux-form'
import LoadingProgress from '../components/LoadingProgress'
import { push } from 'react-router-redux'

import { updateCalendar } from '../actions/calendars'

import { renderInputField, renderSelectField } from '../utils/forms'

class CalendarPricesAddForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      deleting: false,
    }

    this.submit = this.submit.bind(this);
    this.deletePrices = this.deletePrices.bind(this);
  }

  submit(props) {
    const { calendar } = this.props
    this.setState({ loading: true }); // Start loading

    return this.props.updateCalendar(calendar._id, props)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        this.setState({ loading: false }); // Stop loading
        return response
      })
      .catch(error => {
        this.setState({ loading: false }); // Stop loading on error as well
        throw error;
      });
  }

  deletePrices() {
    const { calendar, handleSubmit } = this.props;

    this.setState({ deleting: true });

    // Use handleSubmit to make sure we have the latest form values
    handleSubmit((values) => {
      // Merge form values with delete flag
      const props = {
        ...values,       // Include all form values
        price: 0,        // Set price to 0 for delete action
        delete: true     // Set delete flag to true
      };

      this.setState({ loading: true });

      return this.props.updateCalendar(calendar._id, props)
        .then(response => {
          if (response.error) {
            throw new SubmissionError({
              _error: response.error.message,
              ...response.error.fields
            });
          }

          this.setState({ loading: false, deleting: false }); // Stop loading
          return response;
        })
        .catch(error => {
          this.setState({ loading: false, deleting: false }); // Stop loading on error as well
          throw error;
        });
    })();
  }


  render() {
    const { error, submitting, handleSubmit, category, customer } = this.props

    if (!customer) {
      return (
        <LoadingProgress />
      )
    }

    return (
      <form onSubmit={handleSubmit(this.submit)} className="mb-3">
        {submitting ? (<div className="row"></div>) : (
          <div className="row">
            <div className="col">
              <Field name="startDate"
                component={renderInputField}
                type="date"
                label="Fecha inicio" />
            </div>
            <div className="col">
              <Field name="endDate"
                component={renderInputField}
                type="date"
                label="Fecha fin" />
            </div>
            <div className="col">
              <Field name="zone"
                component={renderSelectField}
                label="Zona">
                <option value="">Selecciona una zona...</option>
                {customer.Zones.map(zone => {
                  return (
                    <option value={zone.Zone} key={zone.Zone}>
                      {zone.Zone} / {zone.Description}
                    </option>
                  )
                })}
              </Field>
            </div>
            <div className="col">
              {category === 'BAQUEIRA' ? (
                <Field
                  name="type"
                  component={renderSelectField}
                  label="Tipo de Taquilla"
                >
                  <option value="BN3XL">2 PAX</option>
                  <option value="CN3XL">3 PAX</option>
                  <option value="BW3XL">4 PAX</option>
                </Field>
              ) : (
                <Field
                  name="type"
                  component={renderSelectField}
                  label="Tipo de Taquilla"
                >
                  <option value="" key="default">Selecciona un tipo...</option>
                  <option value="BNS" key="BNS">Standard</option>
                  <option value="CNS" key="CNS">Standard Carga</option>
                  <option value="BWS" key="BWS">Standard XL</option>
                  <option value="CWS" key="CWS">Standard Carga XL</option>

                  <option value="BNM" key="BNM">Medium</option>
                  <option value="CNM" key="CNM">Medium Carga</option>
                  <option value="BWM" key="BWM">Medium XL</option>
                  <option value="CWM" key="CWM">Medium Carga XL</option>

                  <option value="BNL" key="BNL">Large</option>
                  <option value="CNL" key="CNL">Large Carga</option>
                  <option value="BWL" key="BWL">Large XL</option>
                  <option value="CWL" key="CWL">Large Carga XL</option>

                  <option value="BNXL" key="BNXL">Large 4</option>
                  <option value="CNXL" key="CNXL">Large 4 Carga</option>
                  <option value="BWXL" key="BWXL">Large 4 XL</option>
                  <option value="CWXL" key="CWXL">Large 4 Carga XL</option>

                  <option value="BN2XL" key="BN2XL">Large 5</option>
                  <option value="CN2XL" key="CN2XL">Large 5 Carga</option>
                  <option value="BW2XL" key="BW2XL">Large 5 XL</option>
                  <option value="CW2XL" key="CW2XL">Large 5 Carga XL</option>

                  <option value="BN3XL" key="BN3XL">Ski</option>
                  <option value="CN3XL" key="CN3XL">Ski Carga</option>
                  <option value="BW3XL" key="BW3XL">Ski XL</option>
                  <option value="CW3XL" key="CW3XL">Ski Carga XL</option>

                  {/* Voucher/Coupon Types (X and W, no LOCKER prefix) */}
                  <option value="XNS" key="XNS">Standard Cupón</option>
                  <option value="XWS" key="XWS">Standard XL Cupón</option>
                  <option value="XNM" key="XNM">Medium Cupón</option>
                  <option value="XWM" key="XWM">Medium XL Cupón</option>
                  <option value="XNL" key="XNL">Large Cupón</option>
                  <option value="XWL" key="XWL">Large XL Cupón</option>
                  <option value="XNXL" key="XNXL">Large 4 Cupón</option>
                  <option value="XWXL" key="XWXL">Large 4 XL Cupón</option>
                  <option value="XN2XL" key="XN2XL">Large 5 Cupón</option>
                  <option value="XW2XL" key="XW2XL">Large 5 XL Cupón</option>
                  <option value="XN3XL" key="XN3XL">Ski Cupón</option>
                  <option value="XW3XL" key="XW3XL">Ski XL Cupón</option>
                </Field>
              )
              }
            </div>
            <div className="col">
              <Field
                name="price"
                component={renderInputField}
                type="number"
                label="Precio"
              />
            </div>
          </div>
        )}
        <div className="form-row">
          {error && <div className="alert alert-danger">{error}</div>}
        </div>
        <div className="form-row justify-content-center mt-3">
          {submitting ? (<div className="loading-wheel"></div>) : (
            <>
              <button className="btn bg-vw-dark text-white mr-1"
                type="submit"
                disabled={submitting}>
                <i className="fas fa-edit mr-1"></i>
                Añadir precios
              </button>
              <button className="btn btn-danger ml-2"
                type="button"
                onClick={() => handleSubmit(this.deletePrices)()}
                disabled={submitting}>
                <i className="fas fa-trash mr-1"></i>
                Eliminar precios
              </button>
            </>
          )}
        </div>
      </form>
    )
  }
}

// Validation function to check if the price is 0
const validate = values => {
  const errors = {}

  // if (values.price === 0 && !this.state.deleting) {
  //   errors.price = 'El precio no puede ser 0'
  // }

  // You can add other validation rules here

  return errors
}

CalendarPricesAddForm = reduxForm({
  form: 'CalendarPricesAddForm',
  validate,  // Add the validate function here
  onSubmitSuccess: (result, dispatch, props) => {
    props.push(`/calendars/${result.response._id}`)
  },
  enableReinitialize: true
})(CalendarPricesAddForm)

const selector = formValueSelector('CalendarPricesAddForm');

const mapStateToProps = state => {
  const currentYear = new Date().getFullYear();

  const formatDateLocal = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  const firstDayOfYear = formatDateLocal(new Date(currentYear, 0, 1));
  const lastDayOfYear = formatDateLocal(new Date(currentYear, 11, 31));

  return {
    calendar: state.calendars.calendar,
    role: state.auth.role,
    category: state.auth.category,
    id: state.auth.id,
    values: selector(state, 'startDate', 'endDate', 'zone', 'type', 'price'),
    initialValues: {
      startDate: firstDayOfYear,
      endDate: lastDayOfYear,
      zone: '1',
      type: 'BN3XL',
      price: 0
    }
  };
};

const mapDispatchToProps = dispatch => ({
  updateCalendar: bindActionCreators(updateCalendar, dispatch),
  push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(CalendarPricesAddForm)
